<template>
  <a :href="queryString" class="is-link" target="_blank"><i class="fa fa-external-link" aria-hidden="true"></i> <span v-if="showTitle" class="no-highlight">{{query}}</span></a>
</template>
<script>
export default {
  props: {
    query: {
      type: String,
      required: true
    },
    showTitle: {
      type: String,
      default: false,
      required: false
    }
  },
  computed: {
    queryString: function () {
      let start = 'https://www.systembolaget.se/sok-dryck/?searchquery='
      let end = ''
      return start + this.query + end
    }
  }
}
</script>
<style lang="scss">
  .fa-external-link {
    font-size: .75em;
  }
  .no-highlight {
    color: #222;
  }
</style>



// WEBPACK FOOTER //
// VLink.vue?48e676da